import React from 'react'
import { FormControlLabel, Radio } from '@mui/material'
import { RadioItem } from 'common/types'


type RadioItemsProps = {
  items: RadioItem[]
}

export const RadioItems = ({ items }: RadioItemsProps) => {
  return (
    <>
      {
        items.map((item, index) => (
          <FormControlLabel key={index} value={item.value} control={<Radio />} label={item.label} />
        ))
      }
    </>
  )
}
